<template>
  <div class="row transaction">
    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="header-btns">
      <div class="filter-row">
        <div class="col-auto" style="">
          <select
            class="form-control"
            v-model="selectedValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a search parameter</option>
            <option value="accountType">Account Type</option>
            <option value="firstName">Agent Name</option>
            <option value="walletId">Wallet ID</option>
            <option value="phoneNumber">Phone Number</option>
            <option value="pndStatus">PND Status</option>
            <option value="createdAt">Date Created</option>
            <option value="activatedAt">Date Activated</option>
            <option value="loginAccess">Login Access</option>
            <option value="verifiedStatus">KYC Status</option>
            <option value="customerCategory">Agent Category</option>
            <option value="salesOfficer">Sales Officer</option>
            <option value="lienStatus">LIEN Status</option>
          </select>
        </div>

        <div
          class="col-auto"
          v-if="
            selectedValue &&
            selectedValue !== 'accountType' &&
            selectedValue !== 'createdAt' &&
            selectedValue !== 'activatedAt' &&
            selectedValue !== 'pndStatus' &&
            selectedValue !== 'loginAccess' &&
            selectedValue !== 'verifiedStatus' &&
            selectedValue !== 'lienStatus'
          "
        >
          <div class="input-group m-0">
            <input
              id="inlineFormInputGroup"
              class="form-control"
              v-model="searchValue"
              :placeholder="`Enter ${formattedSearchValue}`"
              type="text"
            />
          </div>
        </div>

        <div class="col-auto" v-if="selectedValue === 'accountType'">
          <select
            class="form-control"
            v-model="searchValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select an account type</option>
            <option value="individual-account">Individual Account</option>
            <option value="business-account">Business Account</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'pndStatus'">
          <select
            class="form-control"
            v-model="searchValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a PND Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'loginAccess'">
          <select
            class="form-control"
            v-model="searchValue"
            :placeholder="'Select a login access'"
          >
            <option value="">Select a Login Access</option>
            <option value="disabled">Disabled</option>
            <option value="enabled">Enabled</option>
          </select>
        </div>

        <div class="col-auto" v-if="selectedValue === 'verifiedStatus'">
          <select
            class="form-control"
            v-model="searchValue"
            :placeholder="'Select a login access'"
          >
            <option value="">Select a KYC Status</option>
            <option value="verified">Verified</option>
            <option value="partially_verified">Partially Verified</option>
            <option value="pending">Pending</option>
            <option value="rejected">Rejected</option>
            <option value="unverified">Unverified</option>
          </select>
        </div>

        <div
          class="row"
          style="display: flex; gap: 8px"
          v-if="selectedValue === 'createdAt'"
        >
          <div class="col-md-4 p-0" style="width: 100%; max-width: 45%">
            <fg-input
              type="date"
              label="Start Date"
              placeholder="Start Date"
              v-model="createdAtStartDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>
          <div class="col-md-4 p-0" style="width: 100%; max-width: 45%">
            <fg-input
              type="date"
              label="End Date"
              placeholder="End Date"
              v-model="createdAtEndDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>
        </div>

        <div
          class="row"
          style="display: flex; gap: 8px"
          v-if="selectedValue === 'activatedAt'"
        >
          <div class="col-md-4 p-0" style="width: 100%; max-width: 45%">
            <fg-input
              type="date"
              label="Start Date"
              placeholder="Start Date"
              v-model="activationStartDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>

          <div class="col-md-4 p-0" style="width: 100%; max-width: 45%">
            <fg-input
              type="date"
              label="End Date"
              placeholder="End Date"
              v-model="activationEndDate"
              :max="new Date().toISOString().split('T')[0]"
            >
            </fg-input>
          </div>
        </div>

        <div class="col-auto" v-if="selectedValue === 'lienStatus'">
          <select
            class="form-control"
            v-model="searchValue"
            placeholder="Select a search parameter"
          >
            <option value="">Select a LIEN Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div class="">
          <button
            type="submit"
            class="btn btn-blue"
            :disabled="dateError || isSearchDisabled"
            @click="refresh('filter')"
          >
            Search
          </button>
        </div>
        <div class="">
          <button class="btn btn-blue" @click="refresh('download')">
            Download list
          </button>
        </div>

        <div class="">
          <button class="btn btn-blue" @click="refresh('reload')">
            Refresh
          </button>
        </div>
      </div>

      <div class="">
        <router-link class="btn btn-info m-2" :to="`/dashboard/add-account`">
          ADD AGENT
        </router-link>
      </div>
    </div>
    <p v-if="dateError" style="color: red; font-size: 12px; margin: 0">
      End Date cannot be earlier than Start Date.
    </p>

    <div class="col-12 p-0">
      <card class="card-plain p-0">
        <div class="table-responsive p-0">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">Agent Name</th>
                <th scope="col" class="text-center">Agent Category</th>
                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">Wallet ID</th>
                <th scope="col" class="text-center">Account Type</th>
                <th scope="col" class="text-center">Tier</th>
                <th scope="col" class="text-center">PND Status</th>
                <th scope="col" class="text-center">LIEN Status</th>
                <th scope="col" class="text-center">Date Created</th>
                <th scope="col" class="text-center">Date Activated</th>
                <th scope="col" class="text-center">Activated By</th>
                <th scope="col" class="text-center">KYC Status</th>
                <th scope="col" class="text-center">Login Access</th>
                <th scope="col" class="text-center">Sales Officer</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading === true">
                <td colspan="100%" class="text-center">
                  <div>
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-else-if="agentList.length === 0 && loading === false">
                <td colspan="100%" class="text-center">
                  <div class="">
                    <div class="alert-icon">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <span>No Agents Found</span>
                  </div>
                </td>
              </tr>

              <template v-else>
                <tr
                  v-for="(agent, index) in agentList"
                  :key="agent._id"
                  style="background-color: #fff"
                >
                  <th class="text-center">
                    {{ limit * (page - 1) + (index + 1) }}
                  </th>

                  <td class="text-center">
                    {{ agent.firstName }} {{ agent.middleName }}
                    {{ agent.lastName }}
                  </td>

                  <td class="text-center">
                    {{ getMerchantName(agent.merchantId) }}
                  </td>

                  <td class="text-center">{{ agent.phoneNumber }}</td>

                  <td class="text-center">{{ agent.walletId }}</td>
                  <td class="text-center" style="text-transform: capitalize">
                    {{ removeAccountSuffix(agent.accountType) }}
                  </td>

                  <td class="text-center text-uppercase">
                    {{ formatTier(agent.accountType, agent.tier) }}
                  </td>

                  <td class="text-center text-uppercase">
                    <span
                      class="status"
                      :class="{
                        'status-enabled': agent.PNDStatus === 'active',
                        'status-disabled': agent.PNDStatus === 'inactive',
                        'status-other': agent.PNDStatus === 'N/A',
                      }"
                      >{{ agent.PNDStatus }}</span
                    >
                  </td>

                  <td class="text-center text-uppercase">
                    <span
                      class="status"
                      :class="{
                        'status-enabled': agent.LienStatus === 'active',
                        'status-disabled': agent.LienStatus === 'inactive',
                        'status-other': agent.LienStatus === 'N/A',
                      }"
                      >{{ agent.LienStatus }}</span
                    >
                  </td>

                  <td class="text-center">
                    {{ moment(agent.createdAt).format("DD.MM.YYYY hh:mm") }}
                  </td>

                  <td class="text-center" v-if="agent.activatedAt">
                    {{ moment(agent.activatedAt).format("DD.MM.YYYY hh:mm") }}
                  </td>
                  <td class="text-center" v-else>Inactive</td>
                  <td class="text-center">{{ agent.activitedBy }}</td>
                  <td class="text-center">
                    <span
                      class="statuses"
                      :class="{
                        'all-status-verified':
                          agent.verifiedStatus === 'verified',
                        'all-status-partially-verified':
                          agent.verifiedStatus === 'partially_verified',
                        'all-status-rejected':
                          agent.verifiedStatus === 'rejected',
                        'all-status-pending':
                          agent.verifiedStatus === 'pending',
                        'all-status-unverified':
                          agent.verifiedStatus === 'unverified',
                      }"
                      >{{ getFormattedStatus(agent.verifiedStatus) }}</span
                    >
                  </td>
                  <td class="text-center text-uppercase">
                    <span
                      class="status"
                      :class="
                        agent.disabled ? 'status-disabled' : 'status-enabled'
                      "
                      >{{ agent.disabled ? "Disabled" : "enabled" }}</span
                    >
                  </td>
                  <td class="text-center">
                    {{ getSalesOfficerName(agent.salesOfficerId) || "N/A" }}
                  </td>

                  <td class="text-center">
                    <virtual-dropdown
                      title="Options"
                      :is-open="agent.isDropdownOpen"
                      @change="toggleDropdown(agent._id)"
                    >
                      <div class="virtual-dropdown-list">
                        <div class="p-2 virtual-dropdown-item">
                          <img
                            src="@/assets/img/fileIcon.svg"
                            alt="file-icon"
                          />
                          <router-link
                            :to="
                              agent.accountType === 'business-account'
                                ? `/dashboard/business-account-agent/${agent._id}`
                                : `/dashboard/agent/${agent._id}`
                            "
                          >
                            View Details
                          </router-link>
                        </div>
                        <div class="p-2 virtual-dropdown-item">
                          <img
                            src="@/assets/img/postAddIcon.svg"
                            alt="post-icon"
                          />
                          <router-link
                            :to="`/dashboard/virtual-accounts/${agent._id}?name=${agent.firstName} ${agent.lastName}`"
                          >
                            View Virtual Accounts
                          </router-link>
                        </div>
                      </div>
                    </virtual-dropdown>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <div class="pagination">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import { convertArrayToCSV } from "convert-array-to-csv";
import fileDownload from "js-file-download";
import { formatTier } from "../utils/utils";
export default {
  data() {
    return {
      currentPage: 1,
      loading: false,
      error: false,
      errorMsg: "",
      moment,
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      page: 1,
      limit: 50,
      totalPages: 0,
      totalDocs: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
      agentList: [],
      filteredAgentList: [],
      download: false,
      searchValues: {
        walletId: "",
        phoneNumber: "",
        firstName: "",
        accountType: "",
        createdAt: "",
        activatedAt: "",
        pndStatus: "",
        loginAccess: "",
        verifiedStatus: "",
        customerCategory: "",
        salesOfficer: "",
        lienStatus: "",
      },
      selectedValue: "",
      inputError: false,
      createdAtStartDate: "",
      createdAtEndDate: "",
      activationStartDate: "",
      activationEndDate: "",
      dateError: false,
      previousValue: "",
      allSalesOfficers: [],
      allMerchants: [],
    };
  },

  computed: {
    formattedSearchValue() {
      return this.selectedValue
        ? this.selectedValue
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/\b\w/g, (char) => char.toUpperCase())
        : "";
    },

    searchValue: {
      get() {
        return this.selectedValue ? this.searchValues[this.selectedValue] : "";
      },
      set(value) {
        if (this.selectedValue) {
          this.searchValues[this.selectedValue] = value;
        }
      },
    },

    isSearchDisabled() {
      switch (this.selectedValue) {
        case "accountType":
          return !this.searchValue;

        case "firstName":
          return !this.searchValue || this.searchValue.trim().length === 0;

        case "walletId":
        case "phoneNumber":
          return !this.searchValue || !/^\d+$/.test(this.searchValue);

        case "pndStatus":
          return !this.searchValue;
        case "lienStatus":
          return !this.searchValue;
        case "createdAt":
          return !this.createdAtStartDate || !this.createdAtEndDate;

        case "activatedAt":
          return !this.activationStartDate || !this.activationEndDate;
        case "loginAccess":
          return !this.searchValue;
        case "verifiedStatus":
          return !this.searchValue;
        case "customerCategory":
          return !this.searchValue;
        case "salesOfficer":
          return !this.searchValue;
        default:
          return true;
      }
    },
  },

  methods: {
    formatTier,
    removeAccountSuffix(accountType) {
      return (accountType || "").replace("-account", "");
    },

    toggleDropdown(id) {
      this.agentList = this.agentList.map((agent) => {
        if (agent._id === id) {
          agent.isDropdownOpen = !agent.isDropdownOpen;
        } else {
          agent.isDropdownOpen = false;
        }
        return agent;
      });
    },

    getFormattedStatus(status) {
      const statusMap = {
        verified: "Verified",
        partially_verified: "Partially Verified",
        rejected: "Rejected",
        pending: "Pending",
        unverified: "Unverified",
      };
      return statusMap[status] || status;
    },

    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;

        //     if (this.dateError) {
        //   this.loading = false;
        //   console.warn("Date error: payload not sent");
        //   return;
        // }

        let payload = {
          page: this.page,
          firstName: this.firstName,
          download: this.download,
          pndStatus: this.PNDStatus,
          loginAccess: this.loginAccess,
          verifiedStatus: this.verifiedStatus,
          lienStatus: this.lienStatus,
          ...this.searchValues,
        };

        payload = {
          ...payload,
          createdAtStartDate: this.createdAtStartDate,
          createdAtEndDate: this.createdAtEndDate,
          activationStartDate: this.activationStartDate,
          activationEndDate: this.activationEndDate,
        };

        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
          case "download":
            payload = { ...payload, download: true };
            break;
          case "filter":
            this.page = 1;
            this.currentPage = 1;

            payload = {
              ...payload,
              page: this.page,
              ...this.searchValues,
            };
            break;
          case "reload":
            this.page = 1;
            payload = {
              page: this.page,
            };
            this.selectedValue = "";
            this.searchValues = "";
            this.currentPage = 1;
            this.activationStartDate = "";
            this.activationEndDate = "";
            this.createdAtStartDate = "";
            this.createdAtEndDate = "";
            break;
        }

        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/agent-list`,
          payload,
        );

        if (mode === "download") {
          const csvTran = convertArrayToCSV(res.data.agentList);
          fileDownload(csvTran, "agents_list.csv");
        } else {
          const {
            docs,
            hasNextPage,
            hasPrevPage,
            totalPages,
            prevPage,
            nextPage,
            totalDocs,
            page,
          } = res.data.agentList;
          this.merchants = docs.map((merchant) => ({
            ...merchant,
            isDropdownOpen: false,
          }));
          this.agentList = docs;
          this.filteredAgentList = docs;
          this.hasPrevPage = hasPrevPage;
          this.hasNextPage = hasNextPage;
          this.totalPages = totalPages;
          this.prevPage = prevPage;
          this.nextPage = nextPage;
          this.totalDocs = totalDocs;
          this.page = page;
        }
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Download Agents List";
      }
      this.loading = false;
    },

    clearSearchFields() {
      this.searchValues = {
        terminalId: "",
        walletId: "",
        phoneNumber: "",
        firstName: "",
        accountType: "",
        reference: "",
        stan: "",
        createdAt: "",
        activatedAt: "",
        pndStatus: "",
        loginAccess: "",
        verifiedStatus: "",
        customerCategory: "",
        salesOfficer: "",
        lienStatus: "",
      };
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getSalesOfficerName(id) {
      const officer = this.allSalesOfficers.find(
        (officer) => officer._id === id,
      );
      if (!officer) return "";

      return officer.lastName
        ? `${officer.firstName} ${officer.lastName}`
        : officer.firstName;
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/merchant/get-all-merchants`,
        );
        const { merchants } = res.data;
        this.allMerchants = merchants;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    getMerchantName(id) {
      const merchant = this.allMerchants.find(
        (merchant) => merchant._id === id,
      );
      return merchant ? merchant.merchantName : "";
    },
  },

  watch: {
    selectedValue(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        const tempValue = newValue;
        this.refresh("reload");
        this.selectedValue = tempValue;
      }
      this.clearSearchFields();
      this.previousValue = newValue;
    },

    createdAtStartDate(newStart) {
      if (this.createdAtEndDate && newStart > this.createdAtEndDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },

    createdAtEndDate(newEnd) {
      if (this.createdAtStartDate && newEnd < this.createdAtStartDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },

    activationStartDate(newStart) {
      if (this.activationEndDate && newStart > this.activationEndDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },

    activationEndDate(newEnd) {
      if (this.activationStartDate && newEnd < this.activationStartDate) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },
  },

  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(
        `${process.env.VUE_APP_API_URL}/agent-list`,
        {
          page: this.page,
        },
      );
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.agentList;
      this.agentList = docs;
      this.filteredAgentList = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Agents";
    }
    this.loading = false;
    await this.getSalesOfficers();
    await this.getMerchants();
  },
};
</script>

<style scoped>
.filter-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  padding: 20px 0;
}

.transaction {
  font-size: 12px;
}

th {
  font-size: 12px !important;
}

.spinner-grow {
  position: fixed;
}

.dropdown-menu {
  background-color: #fff !important;
  position: relative !important;
  width: max-content !important;
}

.virtual-dropdown-list {
  background: white;
  position: absolute;
  border-radius: 8px;
  padding: 4px;
  width: max-content;
  font-size: 0.875rem;
  right: 0;
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
  color: #23242f;
}

.virtual-dropdown-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
}
li {
  list-style: none;
}

.header-btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

#list {
  list-style-type: none;
}
.status {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
}
.status-enabled {
  background: #1eb75b;
  color: #fff;
}
.status-disabled {
  background: #e02b00;
  color: #fff;
}
.status-other {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}

.statuses {
  text-transform: capitalize;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px 12px;
  display: flex;
  justify-content: center;
}

.all-status-verified {
  color: #1eb75b;
  background: rgba(30, 183, 91, 0.1);
}
.all-status-partially-verified {
  color: #b5af03;
  background: rgba(181, 175, 3, 0.1);
}
.all-status-rejected {
  color: #e02b00;
  background: rgba(224, 43, 0, 0.1);
}
.all-status-pending {
  color: #f2b630;
  background: rgba(242, 182, 48, 0.1);
}
.all-status-unverified {
  color: #6880e4;
  background: rgba(104, 128, 228, 0.1);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
</style>
